import { jsxs as o, jsx as e, Fragment as p } from "react/jsx-runtime";
import { SanityImageRatio as w } from "../ImageRatio/SanityImageRatio.js";
import { R as S } from "../ResponsiveSanityImage-BfPbiFwC.js";
import { ShorexDrawerTags as u } from "./ShorexDrawerTags/ShorexDrawerTags.js";
const x = "ShorexDrawerContent-module_wrapper__SPCrh",
  D = "ShorexDrawerContent-module_body__4Xare",
  C = "ShorexDrawerContent-module_header__ZkFh1",
  v = "ShorexDrawerContent-module_image__eu9Lq",
  N = "ShorexDrawerContent-module_title__yhHDm",
  g = "ShorexDrawerContent-module_code__p1BEr",
  y = "ShorexDrawerContent-module_price__AdGzI",
  f = "ShorexDrawerContent-module_content__SWzq6",
  b = "ShorexDrawerContent-module_note__93YZU",
  r = {
    wrapper: x,
    body: D,
    header: C,
    image: v,
    title: N,
    code: g,
    price: y,
    content: f,
    note: b
  },
  H = _ref => {
    let {
      image: t,
      title: c,
      children: s,
      excursionInfoBox: n,
      priceFormattedAmount: a,
      mainCategory: l,
      subCategory: m,
      note: d,
      cruiseType: h,
      newTagLabel: _,
      code: i
    } = _ref;
    return /* @__PURE__ */o("div", {
      className: r.wrapper,
      children: [t && /* @__PURE__ */e(w, {
        ratio: "auto",
        image: t,
        children: /* @__PURE__ */e(S, {
          image: t,
          defaultWidth: 480,
          defaultHeight: 200,
          className: r.image,
          fit: "original"
        })
      }), /* @__PURE__ */o("div", {
        className: r.body,
        children: [/* @__PURE__ */o("div", {
          className: r.header,
          children: [/* @__PURE__ */e(u, {
            newLabel: _,
            mainCategory: l,
            subCategory: m,
            cruiseType: h
          }), /* @__PURE__ */e("div", {
            className: r.title,
            children: c
          }), i && /* @__PURE__ */e("div", {
            className: r.code,
            children: i
          }), a && /* @__PURE__ */e("div", {
            className: r.price,
            children: a
          })]
        }), n && /* @__PURE__ */e(p, {
          children: n
        }), /* @__PURE__ */e("div", {
          className: r.content,
          children: s
        }), d && /* @__PURE__ */e("div", {
          className: r.note,
          children: d
        })]
      })]
    });
  };
export { H as ShorexDrawerContent };